const ENVIRONMENT_ENUM = {
  TEST: 'test',
  PRODUCTION: 'production',
  LIVE: 'live',
  STAGING: 'staging'
}

const isTestAccount = accountType => {
  return accountType === ENVIRONMENT_ENUM.TEST
}

const isProductionAccount = accountType => {
  return accountType === ENVIRONMENT_ENUM.PRODUCTION
}

export { ENVIRONMENT_ENUM, isTestAccount, isProductionAccount }
